module.exports = __webpack_public_path__ + "static/media/funchal-5.271f3b2e.jpg";